import React from "react"
import styled from "styled-components"
import AcFrameBox from "~/components/atoms/AcFrameBox"
import { Col, Row } from "react-bootstrap"
import AcIcon from "~/components/atoms/AcIcon"
import Link from "next/link"
import { ReactChild } from "react"
import { useState } from "react"
import { useEffect } from "react"
import { ReactNode } from "react"
import AcButton from "~/components/atoms/AcButton"
import { UrlObject } from "url"

interface Props {
  title?: string
  right?: ReactChild
  rightHref?: UrlObject
  theme?: "dark" | "light" | string
  headers: {
    key: string
    title?: string
    width?: string
    render?: (data: any, columnData: any) => ReactChild
  }[]
  dataSources: { [KEY in string]: any }[]
  limit?: number
  fulWidth?: boolean
  onMore?: () => void
}

function ListView(props: Props) {
  const { title, right, theme, headers, dataSources, limit, onMore, rightHref, fulWidth } = props
  return (
    <Content theme={theme} fullWidth={fulWidth}>
      {dataSources?.length > 0 ? (
        <>
          <LinkArea>
            <div className={"title"}>{title}</div>
            {right && rightHref && (
              <Link href={rightHref}>
                <div className={"right"}>{right}を一覧表示</div>
              </Link>
            )}
          </LinkArea>
          <Main theme={theme}>
            {headers.some((header) => header.title) && (
              <HeaderArea>
                {headers.map((header, headerIndex) => (
                  <React.Fragment key={headerIndex}>
                    <div
                      className={header.key}
                      style={{ width: `${header.width ? header.width : 100}` }}
                    >
                      {header.title}
                    </div>
                  </React.Fragment>
                ))}
              </HeaderArea>
            )}
            {dataSources && (
              <Table theme={theme}>
                {dataSources.map((dataSource, dataSourceIndex) => (
                  <React.Fragment key={dataSourceIndex}>
                    <div className={"table-row"}>
                      {headers.map((header, i) => (
                        <div
                          className={header.key}
                          key={i}
                          style={{ width: `${header.width ? header.width : 100}` }}
                        >
                          <React.Fragment key={i}>
                            {header.render
                              ? header.render(dataSource[header.key], dataSource)
                              : dataSource[header.key]}
                          </React.Fragment>
                        </div>
                      ))}
                    </div>
                  </React.Fragment>
                ))}
              </Table>
            )}
          </Main>
        </>
      ) : (
        <EmptyTable>
          <div className="empty-title">{title}</div>
          <div>タスクはありません</div>
        </EmptyTable>
      )}
    </Content>
  )
}

const Main = styled.div`
  a {
    color: #4f4ce6;
  }
  margin-bottom: 15px;
  margin: 0px 20px 20px 20px;
`
const Content = styled.div`
  background-color: #${(props) => (props.theme === "light" ? "f6f9fc" : "F4F4F4")};
  width: ${(props) => (props.fullWidth ? "100%" : "48%")};
  ${(props) =>
    !props.theme.length && `border-top: 1px solid #D3D3D3;border-bottom: 1px solid #D3D3D3;`}
`

const LinkArea = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px;

  .title {
    font-size: 16px;
    font-weight: bold;
  }

  .right {
    color: #4f4ce6;
    cursor: pointer;
  }
`

const HeaderArea = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #f9fafc;
  border-top: 1px solid #d1d1d1;
  border-bottom: 1px solid #d1d1d1;
  height: 60px;
  font-weight: 600;

  > div {
    text-align: center;
  }
`

const Table = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 360px;
  overflow: auto;

  > div {
    display: flex;
    text-align: center;
  }

  .table-row {
    display: flex;
    align-items: center;
    min-height: 72px;
    border-bottom: 1px dashed #d3d3d3;
    justify-content: space-around;
    background-color: #ffffff;
    &:first-child {
      ${(props) => !props.theme.length && `border-top: 1px dashed #D3D3D3;`}
    }

    .contractName,
    .name {
      color: #4f4ce6;
    }

    .propertyName {
      text-align: left;
    }
  }
`
const EmptyTable = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 240px;
  position: relative;
  .empty-title {
    position: absolute;
    top: 20px;
    left: 20px;
    font-size: 16px;
    font-weight: bold;
  }
`

export default React.memo(ListView)
